export default __webpack_public_path__ + "static/media/service02.d03b3548.svg";